/* Site-wide "Continue your design" reminder for an unfinished Truly Custom draft (localStorage 'sjwTcxDraft'). */
(function(){
  var KEY='sjwTcxDraft', TTL=1209600000, OFF='sjwTcxPillOff', PATH='/pages/truly-custom';
  var path=location.pathname.replace(/\/+$/,'');
  if(path===PATH||/^\/(cart|checkout|account)/.test(path)||/^\/[a-z]{2}(-[a-z]{2})?\/pages\/truly-custom$/i.test(path))return;
  try{if(sessionStorage.getItem(OFF))return;}catch(e){}
  var d;try{d=JSON.parse(localStorage.getItem(KEY)||'null');}catch(e){return;}
  if(!d||!d.piece)return;
  if(d.t&&Date.now()-d.t>TTL)return;
  var NOUN={womens:'ring',mens:'ring',earrings:'earrings',necklace:'necklace',bracelet:'bracelet',chain:'chain'};
  var noun=NOUN[d.piece]?'Your '+NOUN[d.piece]+' design':'Your design';
  var step=Math.max(1,Math.min(5,parseInt(d.step,10)||2));
  var PIECE=/^(womens|mens|earrings|necklace|bracelet|chain|else)$/.test(d.piece)?d.piece:'unknown';
  /* Anonymous count for the funnel dashboard (same rules as the Truly Custom page). */
  function stat(action,once){
    try{var cp=window.Shopify&&window.Shopify.customerPrivacy;if(cp&&cp.analyticsProcessingAllowed&&!cp.analyticsProcessingAllowed())return;if(navigator.globalPrivacyControl)return;}catch(e){}
    var sk='sjwTcxStat:'+action;try{if(once&&sessionStorage.getItem(sk))return;}catch(e){}
    var body=JSON.stringify({a:action,s:step,p:PIECE,d:''});
    try{if(!(navigator.sendBeacon&&navigator.sendBeacon('https://signora-tcx-stats.signorajewels-store.workers.dev/e',new Blob([body],{type:'text/plain'}))))fetch('https://signora-tcx-stats.signorajewels-store.workers.dev/e',{method:'POST',body:body,keepalive:true,mode:'no-cors'});if(once)sessionStorage.setItem(sk,'1');}catch(e){}
  }

  function show(){
    if(document.querySelector('.sjw-resume-pill'))return;
    var st=document.createElement('style');
    st.textContent='.sjw-resume-pill{position:fixed;left:16px;bottom:16px;z-index:60;display:flex;align-items:center;gap:12px;max-width:calc(100vw - 104px);width:340px;box-sizing:border-box;padding:12px 10px 12px 14px;background:#FFFDFB;border:1px solid rgba(194,168,120,.55);border-radius:14px;box-shadow:0 18px 40px -18px rgba(20,38,30,.45);font-family:var(--font-body,inherit);color:#1F2A24;opacity:0;transform:translateY(12px);transition:opacity .35s ease,transform .35s ease,bottom .25s ease}'
      +'.sjw-resume-pill.is-in{opacity:1;transform:none}'
      +'.sjw-resume-pill__seal{flex:none;width:38px;height:38px;border-radius:50%;background:#2C4A41;color:#E7D3A8;display:flex;align-items:center;justify-content:center;font-size:16px}'
      +'.sjw-resume-pill__go{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;text-decoration:none;color:inherit}'
      +'.sjw-resume-pill__go b{font-weight:500;font-size:14.5px;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
      +'.sjw-resume-pill__go span{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#7E6535}'
      +'.sjw-resume-pill__x{flex:none;width:36px;height:36px;border:0;background:none;border-radius:50%;color:#6B655D;font-size:20px;line-height:1;cursor:pointer}'
      +'.sjw-resume-pill__x:hover{background:rgba(194,168,120,.15)}'
      +'html[data-sjw-theme="dark"] .sjw-resume-pill{background:#1B2620;color:#F3EEE4;border-color:rgba(194,168,120,.45)}'
      +'html[data-sjw-theme="dark"] .sjw-resume-pill__go span{color:#D9C08F}'
      +'html[data-sjw-theme="dark"] .sjw-resume-pill__x{color:#C9C2B6}'
      +'.sjw-resume-pill.is-mini{width:auto;padding:4px;border-radius:50%;gap:0}'
      +'.sjw-resume-pill.is-mini .sjw-resume-pill__go b,.sjw-resume-pill.is-mini .sjw-resume-pill__go span,.sjw-resume-pill.is-mini .sjw-resume-pill__x{display:none}'
      +'.sjw-resume-pill.is-mini .sjw-resume-pill__go{position:absolute;inset:0;border-radius:50%}'
      +'.sjw-resume-pill.is-mini .sjw-resume-pill__seal{width:44px;height:44px}'
      +'@media (prefers-reduced-motion:reduce){.sjw-resume-pill{transition:none}}';
    document.head.appendChild(st);
    var el=document.createElement('div');
    el.className='sjw-resume-pill';
    el.setAttribute('role','region');
    el.setAttribute('aria-label','Unfinished design');
    el.innerHTML='<span class="sjw-resume-pill__seal" aria-hidden="true">&#10022;</span>'
      +'<a class="sjw-resume-pill__go" href="'+PATH+'?resume=pill"><b>'+noun+' is waiting</b><span>Step '+step+' of 5 &middot; Continue &rarr;</span></a>'
      +'<button type="button" class="sjw-resume-pill__x" aria-label="Hide this reminder">&times;</button>';
    document.body.appendChild(el);
    stat('pill_shown',true);
    el.querySelector('.sjw-resume-pill__go').addEventListener('click',function(){stat('pill_click',false);});
    el.querySelector('.sjw-resume-pill__x').onclick=function(){
      try{sessionStorage.setItem(OFF,'1');}catch(e){}
      stat('pill_dismiss',false);
      el.classList.remove('is-in');setTimeout(function(){el.remove();},350);
    };
    requestAnimationFrame(function(){el.classList.add('is-in');});
    /* On phones, shrink to a small seal after a few seconds so it never sits on top of content. */
    if(window.matchMedia&&window.matchMedia('(max-width:749px)').matches){
      setTimeout(function(){el.classList.add('is-mini');el.querySelector('.sjw-resume-pill__go').setAttribute('aria-label',noun+' is waiting. Continue');},8000);
    }

    /* Lift above the mobile sticky Add to Cart on product pages. */
    var bar=document.querySelector('[data-sjwpp-sticky]');
    if(bar){
      var calc=function(){el.style.bottom=bar.classList.contains('is-visible')?Math.max(16,Math.round(window.innerHeight-bar.getBoundingClientRect().top)+12)+'px':'';};
      /* Measure again once the bar's slide-in transition has finished. */
      var lift=function(){calc();setTimeout(calc,450);};
      try{new MutationObserver(lift).observe(bar,{attributes:true,attributeFilter:['class']});}catch(e){}
      window.addEventListener('resize',lift);
      lift();
    }
  }
  /* Wait a moment so it never competes with the first view of the page. */
  function later(){setTimeout(show,2500);}
  if(document.readyState==='complete')later();else window.addEventListener('load',later);
})();
